import script from "./NewsPagePagination.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsPagePagination.vue?vue&type=script&setup=true&lang=js"

import "./NewsPagePagination.vue?vue&type=style&index=0&id=66981da6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66981da6"]])

export default __exports__